import { create } from "zustand";

/**
 * @description useWarningModal - A Zustand store for managing warning modal state.
 *
 * State in order to be used:
 * - customChildren: Custom React components to be rendered inside the modal.
 * 		If this is defined, will override title, body, and code.
 * - title: The title of the warning modal.
 * - body: The body content of the warning modal.
 * 		If body is null, the modal will not be shown unless customChildren is provided.
 * 		If this is defined, will override code.
 * - code: An optional code that can be used to determine specific messages.
 * 		If code is defined and body is null, it will show predefined messages based on the code.
 * Actions:
 * - setBody: Function to set the title, body, code, and customChildren of the modal.
 * - clearBody: Function to reset the modal state to its default values.
 *
 * @example const { title, body, customChildren, code, setBody, clearBody } = useWarningModal();
 */

export const useWarningModal = create((set) => ({
	title: "Warning",
	body: null,
	image: null,
	customChildren: null,
	code: null,
	setBody: ({
		title, body, image, code, customChildren,
	}) =>
		set({
			title,
			body,
			image,
			customChildren,
			code,
		}),
	clearBody: () =>
		set({
			title: "Warning",
			body: null,
			image: null,
			customChildren: null,
			code: null,
		}),
}));
